$(document).ready(function(){

	Fancybox.bind("[data-fancybox]", {
		Toolbar: {
	    display: [
	      "counter",
	      "fullscreen",
	      "close",
	    ],
	  },
	  Thumbs : false
	});

});